/**
 * Componente: Confirmación de eliminar un diseño
 * Reemplaza el confirm() nativo del navegador por un modal con el mismo
 * estilo visual del resto de la app, mostrando el nombre del diseño.
 */

import React from 'react';
import { IconCerrar } from './icons';

const ConfirmarEliminarDisenoModal = ({ nombre, eliminando, onConfirmar, onCancelar }) => (
  <div className="modal-overlay">
    <div className="modal-content confirmar-eliminar-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>Eliminar diseño</h2>
        <button className="modal-close" onClick={onCancelar} disabled={eliminando}><IconCerrar size={18} /></button>
      </div>

      <div className="modal-body">
        <p>
          ¿Eliminar el diseño <strong>"{nombre}"</strong>?
        </p>
        <p className="form-hint">Esta acción no se puede deshacer.</p>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn-cancelar" onClick={onCancelar} disabled={eliminando}>
          Cancelar
        </button>
        <button type="button" className="btn-eliminar-confirmar" onClick={onConfirmar} disabled={eliminando}>
          {eliminando ? 'Eliminando...' : 'Eliminar'}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmarEliminarDisenoModal;
